import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrorsService } from '../../../../services/errors-service/errors.service';
import { INotificationContent } from '../notification/notification.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';

export interface IErrorContent {
  errorName: string;
  formattedMessage: string;
  message: string;
  params: string[];
}

@Component({
  selector: 'error-modal',
  templateUrl: 'error-modal.component.html',
  styleUrls: ['error-modal.component.scss'],
  standalone: true,
  imports: [TranslatePipe],
})
export class ErrorModalComponent implements OnInit {
  @Output() public onClose: EventEmitter<void> = new EventEmitter<void>();
  public errorContentList: IErrorContent[] = [];
  public content = {
    color: '#ffbbbb',
    fontColor: '#ad120d',
    IconName: 'error',
  };

  constructor(private errorsService: ErrorsService) {}

  ngOnInit() {
    this.errorContentList = this.errorsService.errorContentList;
    this.errorContentList = this.errorContentList.map(error => {
      if (error.errorName === 'CUSTOM_ERROR_MESSAGE') {
        return {
          ...error,
          params: [
            typeof error.formattedMessage === 'string'
              ? JSON.parse(error.formattedMessage).Message
              : error.formattedMessage
          ]
        };
      }
      return error;
    });
    setTimeout(() => this.onClose.emit(), 3000);
  }

  public closeModal() {
    this.onClose.emit();
  }
}
